import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { FadeIn, Chapter } from "@/components/Motion";
import { NEWS } from "@/data/content";

const fmt = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

export default function News() {
  const [featured, ...rest] = NEWS;
  return (
    <>
      <PageHero
        overline="Newsroom"
        lines={["Technology, innovation,", "and the network"]}
        sub="Product launches, engineering milestones and dealer stories from the ACTIVE platform."
      />

      <section className="bg-white pb-24 sm:pb-32" data-testid="news-list">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Chapter index="01" label="Latest" />
          <FadeIn>
            <article
              className="group grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden border border-slate-200/80 bg-[#F8F9FA] mb-6"
              data-testid="news-featured"
            >
              <div className="overflow-hidden spotlight-frame">
                <img src={featured.image} alt={featured.title} loading="lazy" className="w-full h-72 lg:h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-8 sm:p-12 flex flex-col justify-center bg-white">
                <div className="flex items-center gap-4">
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-signal border border-signal/30 rounded-full px-3 py-1">{featured.category}</span>
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{fmt(featured.date)}</span>
                </div>
                <h2 className="mt-5 font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-950 leading-snug">{featured.title}</h2>
                <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{featured.excerpt}</p>
              </div>
            </article>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {rest.map((n, i) => (
              <FadeIn key={n.slug} delay={(i % 2) * 0.08}>
                <article
                  className="group h-full rounded-2xl border border-slate-200/80 bg-white overflow-hidden hover:border-signal/40 transition-colors duration-300"
                  data-testid={`news-card-${n.slug}`}
                >
                  <div className="overflow-hidden spotlight-frame">
                    <img src={n.image} alt={n.title} loading="lazy" className="w-full h-52 object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-7">
                    <div className="flex items-center gap-4">
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-signal border border-signal/30 rounded-full px-3 py-1">{n.category}</span>
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400">{fmt(n.date)}</span>
                    </div>
                    <h3 className="mt-4 font-display text-lg font-semibold tracking-tight text-slate-950 leading-snug">{n.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{n.excerpt}</p>
                  </div>
                </article>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <CTABand
        overline="Press & Media"
        lines={["Writing about the", "future of access?"]}
        primary={{ to: "/contact?type=marketing", label: "Contact Marketing", testid: "news-cta-press" }}
        secondary={{ to: "/downloads", label: "Media Kit", testid: "news-cta-mediakit" }}
      />
    </>
  );
}
